import { Country } from './country';
import { Chance } from 'chance';
import { snakeCase, escapeRegExp } from 'lodash';
import { InMemoryBackend, InMemoryBackendParams } from '../InMemoryBackend';

export const createCountriesBackend = ({
  createOne,
  ...params
}: Partial<InMemoryBackendParams<Country>> & {
  enableTotal?: boolean;
} = {}) => {
  const chance = new Chance() as Chance.Chance & {
    countries(): {}[];
  };

  const countries = chance
    .unique(
      chance.country.bind(chance, { full: true }),
      chance.countries().length,
    )
    .sort()
    .map((name) => ({
      id: snakeCase(name),
      name,
    }));

  function createCountry(
    index: number,
    { ...rest }: Partial<Country> = {},
  ): Country {
    return {
      ...countries[index],
      ...rest,
    };
  }

  return new InMemoryBackend<Country>({
    enableTotal: params?.enableTotal,
    createOne: createOne ?? ((index) => createCountry(index)),
    itemKey: (item) => item.id,
    total: countries.length,
    predicate: ({ search }) => {
      const rgx = new RegExp(escapeRegExp(search), 'i');

      return (item) => {
        if (search && !rgx.test(item.name)) {
          return false;
        }

        return true;
      };
    },
    ...params,
  });
};
